import { TFunction } from 'i18next';

import projectConfig, { PROJECT } from '~/projects/config';

type PaymentConfig = {
  getCompanyAddress: (t: TFunction) => string;
};

const paymentConfigByProject: Readonly<Record<PROJECT, PaymentConfig>> = {
  [PROJECT.JUSTDONE]: {
    getCompanyAddress: (t: TFunction) =>
      t(
        'subscription:payment_form.agreement_justdone',
        'GM Appdev Limited, with registered address at Nafpliou, 15, Limassol, Cyprus, 3025',
      ),
  },
  [PROJECT.SIDEKICKER]: {
    getCompanyAddress: (t: TFunction) =>
      t(
        'subscription:payment_form.agreement_sidekicker',
        'AV Wellbeing Limited. Florinis, 7, Greg Tower, 2nd floor, 1065, Nicosia, Cyprus',
      ),
  },
  [PROJECT.POLYLLM_CHAT]: {
    getCompanyAddress: (t: TFunction) =>
      t(
        'subscription:payment_form.agreement_polyllm-chat',
        'AV Wellbeing Limited, Florinis, 7, Greg Tower, 2nd floor, 1065, Nicosia, Cyprus',
      ),
  },
};

const getConfigByProject = (): PaymentConfig => {
  return paymentConfigByProject[projectConfig.project];
};

export const PAYMENT_PROJECT_CONFIG = getConfigByProject();
